<template>
  <div v-if="frame" class="filter-tag">
  </div>
</template>
<script>

const speedPresets = {
  'speed-1.5': 1.5,
  'speed-2': 2,
  'speed-3': 3,
  'speed-0.5': 0.5,
  'speed-0.25': 0.25
}

export default {
  name: 'filterTag',
  props: ['meta', 'frame', 'isLastFrame'],
  created() {
    this.initTag()
    this.$nextTick(() => {
      this.videoElement = document.getElementsByClassName('viewer-video')[0]
    })
  },
  data() {
    return {
      showTag: true
    }
  },
  watch: {
    'frame': 'onFrameActive',
    'meta.showTag': 'onShowFilter'
  },
  computed: {},
  directives: {},
  methods: {
    initTag() {
      console.log('filterTag.inited', this.$vnode.tag)
      this.showTag = this.meta.showTag
    },
    onShowFilter(newVal, oldVal) {
      if (newVal) {
        this.addFilter()
      } 
      if (!newVal) {
        this.removeFilter()
      }
    },
    onFrameActive(newVal, oldVal) {
      if (newVal && !oldVal && this.showTag) {
        console.log("toggle filter on")
        this.addFilter()
      } 
      if (!newVal && oldVal) {
        console.log("toggle filter off")
        this.removeFilter()
      }
    },
    addFilter() {
      const filter = this.meta.filter || ''
      this.$nextTick(() => {
        if (filter.startsWith('speed')) {
          this.videoElement.playbackRate = speedPresets[filter] || 1
        } else if (filter.startsWith('mute')) {
          this.videoElement.muted = true
        } else {
          this.videoElement.classList.add(`${this.meta.filter}-filter`)
        }
      })
    },
    removeFilter() {
      const filter = this.meta.filter || ''
       this.$nextTick(() => {
        if (filter.startsWith('speed')) {
          this.videoElement.playbackRate = 1
        } else if (filter.startsWith('mute')) {
          this.videoElement.muted = false
        } else {
          this.videoElement.classList.remove(`${this.meta.filter}-filter`)
        }
      })
    }
  }
}
</script>
